// extracted by mini-css-extract-plugin
module.exports = {"container":"ImgLogo_container__1HP0S","logo":"ImgLogo_logo__1G_4a"};